import React, { createContext, useReducer, ReactNode, useEffect } from "react";
import { appStateReducer } from "./AppReducer";
import { ratingmodelState, Feedback } from "../api";
import { Conversation } from "../api";

export interface AppState {
    OpenLikeModal: boolean;
    OpenDislikeModal: boolean;
    RatingModel: Feedback | null;
    MessageSelected: number;
    Comment: string;
    Checkboxes: boolean[];
    FeedbackModel: Feedback | null;
}

export type Action =
    | { type: "TOGGLE_LIKE_MODAL"; payload: boolean }
    | { type: "SET_DISIKE_MODAL"; payload: boolean }
    | { type: "SET_Rating_MODEL"; payload: Feedback }
    | { type: "SET_Message_Selected"; payload: number }
    | { type: "SET_COMMENT"; payload: string }
    | { type: "SET_CHECKBOXES"; payload: boolean[] };

const initialState: AppState = {
    OpenLikeModal: false,
    OpenDislikeModal: false,
    RatingModel: null,
    MessageSelected: -1,
    Comment: "",
    Checkboxes: [false, false, false],
    FeedbackModel: null
};

export const AppStateContext = createContext<
    | {
          state: AppState;
          dispatch: React.Dispatch<Action>;
      }
    | undefined
>(undefined);

type AppStateProviderProps = {
    children: ReactNode;
};

export const AppStateProvider: React.FC<AppStateProviderProps> = ({ children }) => {
    const [state, dispatch] = useReducer(appStateReducer, initialState);

    return <AppStateContext.Provider value={{ state, dispatch }}>{children}</AppStateContext.Provider>;
};
